export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Play Size',
        category: ['User', 'Plays'],
        description: 'Number of players in a play.',
        summarise: {
            prefix: 'Plays with',
            template: {
                match: {
                    '=': 'Plays with {value} {unit}',
                    '!=': 'Plays not with {value} {unit}'
                }
            }
        },
        unit: 'player'
    }
}